<script>
  import currentIdx from '../store/currentIdx';
  import fieldValues from '../store/fieldValues';
  import Form from '../components/Form.svelte';
  import InputField from '../components/InputField.svelte';

  export let title;
  export let description;
</script>

<Form {title} {description} handlePrevious={currentIdx.decrementIndex}>
  <InputField
    label="Email"
    type="email"
    placeholder="rick.sanchez@pm.me"
    value={$fieldValues['email'] || ''}
    on:input={e => fieldValues.setField('email', e.detail.value)} />
</Form>
